const INITIAL_STATE = {
    isBoardConnected:false,
    isCameraEnabled:false,
};

const reducer = (state=INITIAL_STATE,action) =>{

    switch(action.type)
    {
        case "BOARD_CONNECTED":
            return{
                ...state,
                isBoardConnected:true
            }
        case "BOARD_DISCONNECTED":
            return{
                ...state,
                isBoardConnected:false
            }
        case "CAMERA_ENABLED":
            return{
                ...state,
                isCameraEnabled:false
            }
        case "CAMERA_DISABLED":
            return{
                ...state,
                isCameraEnabled:true
            }
        default:
            return state;
    }
}

const enableCamera = () =>({
    type : "CAMERA_ENABLED"
});

const disableCamera = () =>({
    type: "CAMERA_DISABLED"
});

const boardConnected = () =>({
    type: "BOARD_CONNECTED"
});

const boardDisconnected = () =>({
    type: "BOARD_DISCONNECTED"
});


export {
    reducer as default,
    enableCamera,
    disableCamera,
    boardConnected,
    boardDisconnected
}